import { Injectable, computed, inject, signal } from '@angular/core';
import * as M from '@core/api/models';
import { PageHeaderConfig } from '@shared/components/layout/page-header/page-header.models';
import { TabNavigationConfig } from '@shared/components/layout/tab-navigation/tab-navigation.models';
import { finalize, take } from 'rxjs';

import {
  DEVELOPER_TABS_CONFIG,
  buildDeveloperPageHeaderConfig,
} from '../config/developer-page-chrome.config';
import { DeveloperApiClient } from './developer-api.client';

@Injectable()
export class DeveloperPageChromeFacade {
  private readonly developerApiClient = inject(DeveloperApiClient);

  private readonly hasLoadedSuccessfully = signal(false);
  readonly loading = signal(false);
  readonly loadError = signal<string | null>(null);
  readonly developer = signal<M.DeveloperDto | null>(null);

  readonly headerConfig = computed<PageHeaderConfig>(() =>
    buildDeveloperPageHeaderConfig(this.developer())
  );
  readonly tabsConfig = computed<TabNavigationConfig>(() => DEVELOPER_TABS_CONFIG);

  init(): void {
    if (this.loading()) {
      return;
    }

    this.loading.set(true);
    this.loadError.set(null);

    this.developerApiClient
      .getDeveloper()
      .pipe(
        take(1),
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe({
        next: (developer) => {
          this.developer.set(developer ?? null);
          this.hasLoadedSuccessfully.set(true);
        },
        error: () => {
          // Keep the last successfully loaded developer visible during background refresh failures.
          if (!this.hasLoadedSuccessfully()) {
            this.developer.set(null);
          }
          this.loadError.set('Nie udało się załadować danych dewelopera.');
        },
      });
  }

  setDeveloper(developer: M.DeveloperDto | null): void {
    this.developer.set(developer);
    if (developer) {
      this.hasLoadedSuccessfully.set(true);
      this.loadError.set(null);
    }
  }
}
